module.exports = __webpack_public_path__ + "static/img/primary_icon.5a579cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/account/primary_icon.png
// module id = Ae16
// module chunks = 1